import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { colors } from "../../../styles/utils/vars";
import { cssIcon } from "../../ui/Icon";
import { StyledLinkBase } from "../../ui/Link/StyledLink";
import { StyledList, StyledListItem } from "../StyledList";
export const StyledLinkList = /*#__PURE__*/styled(StyledList)({
  name: "StyledLinkList",
  class: "StyledLinkList_swfo082"
});
export const StyledLinkListItem = /*#__PURE__*/styled(StyledListItem)({
  name: "StyledLinkListItem",
  class: "StyledLinkListItem_s1n74lbw"
});
export const cssCLSocials = "cssCLSocials_c1wdar9g";
export const cssListItemPurple = "cssListItemPurple_c1jar0tl";

require("./StyledLinkList.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledLinkList.tsx");